import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

interface CategoryTabsProps {
  basePath: string;
  active?: string;
  allLabel?: string;
}

export default function CategoryTabs({ basePath, active, allLabel = "全部" }: CategoryTabsProps) {
  const items = [{ id: "", name: allLabel }, ...categories];
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {items.map((item) => {
        const isActive = (active ?? "") === item.id;
        const to = item.id ? `${basePath}/${item.id}` : basePath;
        return (
          <Link
            key={item.id || "all"}
            to={to}
            className={`px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
              isActive
                ? "bg-primary-600 text-background-50 font-semibold"
                : "bg-background-50 border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {item.name}
          </Link>
        );
      })}
    </div>
  );
}